import React, { useState } from 'react';
import { Share2Icon, TaskIcon, WarningIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

import { RateModal, ShareModal } from 'components';

interface IProps {
  ticketId: string;
}

const ActionSection: React.FC<IProps> = ({ ticketId }) => {
  const t = useTranslations();
  const [openRate, setOpenRate] = useState(false);
  const [openShare, setOpenShare] = useState(false);

  return (
    <>
      <div className="mt-5 flex items-center justify-center gap-3">
        <Link
          href={`${globalConst.pageNames.DTM}/check/${ticketId}`}
          className="flex cursor-pointer flex-col items-center justify-center space-y-2 rounded-xl bg-gray-50 p-3"
        >
          <WarningIcon />
          <p className="text-xs text-gray-400">{t('tekshirish')}</p>
        </Link>
        <div
          onClick={() => setOpenRate(true)}
          className="flex cursor-pointer flex-col items-center justify-center space-y-2 rounded-xl bg-gray-50 p-3"
        >
          <TaskIcon />
          <p className="text-xs text-gray-400">{t('baholash')}</p>
        </div>
        <div
          onClick={() => setOpenShare(true)}
          className="flex cursor-pointer flex-col items-center justify-center space-y-2 rounded-xl bg-gray-50 p-3"
        >
          <Share2Icon />
          <p className="text-xs text-gray-400">{t('profile.ulashish')}</p>
        </div>
      </div>

      <RateModal ticketId={ticketId as string} open={openRate} onClose={() => setOpenRate(false)} />
      <ShareModal
        title={t('test_natijalarini_ulashish')}
        shareUrl={`${globalConst.pageNames.DTM_RESULT}/${ticketId}`}
        open={openShare}
        onClose={() => setOpenShare(false)}
      />
    </>
  );
};

export default ActionSection;
